import { render } from "./GaleriasPage.vue?vue&type=template&id=f56ae984&scoped=true"
import script from "./GaleriasPage.vue?vue&type=script&lang=js"
export * from "./GaleriasPage.vue?vue&type=script&lang=js"

import "./GaleriasPage.vue?vue&type=style&index=0&id=f56ae984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56ae984"]])

export default __exports__